var initialState = {
  settings: {},
  printerName: "",
};

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SETTINGS":
      return {
        ...state,
        settings: action.payload,
      };
    case "UPDATE_OTHER_CHARGER":
      console.log("UPDATE_OTHER_CHARGER", action.payload);
      return {
        ...state,
        settings: {
          ...state.settings,
          otherChargesField: action.payload,
        },
      };
    case "SET_PRINTER":
      return {
        ...state,
        printerName: action.payload,
      };
    default:
      return state;
  }
};

export default settingsReducer;
